import { CohortBuilderDefinitionLegacy } from '@verantos-dev/types-cohorts';

export const extractEventName = (rawEventName?: string): string | undefined =>
  rawEventName?.split('::')?.[1]?.replace(/^"|"$/g, '');

export const hasValidEventNameMapping = (cohortDefinition?: CohortBuilderDefinitionLegacy) => {
  const simpleEventNames = cohortDefinition?.simpleEvents.map((event) => event.name) || [];
  const derivedEventNames = cohortDefinition?.derivedEvents.map((event) => event.name) || [];
  const subjectVariableNames = cohortDefinition?.subjectVariables.map((event) => event.name) || [];
  const allEventNames = [...simpleEventNames, ...derivedEventNames, ...subjectVariableNames];

  // Check if derived event is valid
  const derivedEventHasValidEvents = cohortDefinition?.derivedEvents.every((derivedEvent) => {
    return derivedEvent.eventFilters.every((eventFilter) => {
      const eventName = extractEventName(eventFilter.eventName.value);
      return allEventNames.includes(eventName || '');
    });
  });

  // Criteria has valid event
  const subjectVariablesHasValidEvents = cohortDefinition?.subjectVariables.every(
    (subjectVariable) => {
      if (!subjectVariable.countFilter) return true;
      const eventName = extractEventName(subjectVariable.countFilter.inputFields[0].value);
      return allEventNames.includes(eventName || '');
    }
  );

  return {
    isEventNameMappingValid: derivedEventHasValidEvents && subjectVariablesHasValidEvents,
  };
};
